import { render } from "./ComponentEdit.vue?vue&type=template&id=22a870ae&scoped=true"
import script from "./ComponentEdit.vue?vue&type=script&lang=js"
export * from "./ComponentEdit.vue?vue&type=script&lang=js"

import "./ComponentEdit.vue?vue&type=style&index=0&id=22a870ae&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a870ae"]])

export default __exports__